import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
} from "reactstrap"
import CardItem from "./CardItem"
import { providerPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import { useSelector } from "react-redux"
import './styles.scss'
import PropertyService from "services/Provider/PropertyService"

const PropertyList = (props) => {
    const filter = useSelector(state => state.adminFilter)
    const path = filter.path || localStorage.getItem('path')
    const propertyService = new PropertyService()
    const [active, setActive] = useState('all')
    const [modal, setModal] = useState(false)
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [searchWord, setSearchWord] = useState("")
    const [list, setList] = useState([])
    const [exportUrl, setExportUrl] = useState("")
    const [noData, setNoData] = useState(false)

    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })
    const [filterData, setFilterData] = useState({
        unit_type_ids: null,
        min_price: "",
        max_price: "",
        min_size: "",
        max_size: "",
        compound_ids: null,
    })

    const toggle = () => {
        setModal(!modal)
    }

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }

    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {
            const params = {}
            if (active != 'all') params['status'] = active === "active" ? 1 : 0
            if (searchWord.trim().length) params['keyword'] = searchWord
            
            if(!!filter?.building_id || localStorage.getItem('building_id')) params['building_ids'] = filter?.building_id || localStorage.getItem('building_id')
            params['compound_ids'] = filter?.compound_id || localStorage.getItem('compound_id')
            
            if(path == 'toStandaloneProperties'){
                params['standalone'] = 1
            } else if(path == 'PropertiesInBuilding'){
                params['standalone'] = 0
            }
            if (filterData) {
                if(!!filter.unit_type_ids) params['unit_type_ids'] = filter.unit_type_ids
                if (filterData ?.min_price) params['min_price'] = filterData ?.min_price
                if (filterData ?.max_price) params['max_price'] = filterData ?.max_price
                if (filterData ?.min_size && filterData ?.max_size) {
                    params['size_range'] = `${filterData ?.min_size}-${filterData ?.max_size}`
                } else if (filterData ?.max_size) {
                    params['size_range'] = `0-${filterData ?.max_size}`
                } else if (filterData ?.min_size) {
                    params['size_range'] = `${filterData ?.min_size}-0`
                }

            }
            let unit_type = filter.unit_type?.length > 0 ? filter.unit_type : null
            setFilterParams({ ...params })
            setFilterData({...filterData,...params, unit_type : unit_type})
        }, 1000)

        return () => clearTimeout(timeoutId)
    }, [
            active,
            searchWord,
            filter,
            filterData.unit_type_ids,
            filterData.min_size,
            filterData.min_size,
            filterData.min_price,
            filterData.max_price
        ])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Properties</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <div className="d-flex mb-2">
                                <button className="p-0 m-0 border-0 me-2"
                                style={{background: 'none'}}
                                    onClick={() => {
                                        //props.history.location.pathname
                                        if(filter?.path === "PropertiesInBuilding"){
                                            props.history?.push(`${providerPrefix}/Admin-developer/building`)
                                        } else {
                                            props.history?.push(`${providerPrefix}/Admin-developer/cards/${filter?.compound_id || localStorage.getItem('compound_id')}`)
                                        }
                                        
                                    }}>
                                    <i className="fa fa-arrow-left text-success me-2 font-size-16"></i>
                                </button>
                                <h4 className="m-0">Manage {`${filter?.path == 'toStandaloneProperties' ? 'Standalone Properties' : filter?.path == 'allProperties' ? 'All Properties' : 'Properties in Building'}`}</h4>
                            </div>
                            {path == 'allProperties' && <p>You can manage All Properties in the Selected Compound</p>}
                            {path == 'toStandaloneProperties' && <p>You can manage All Standalone Properties in the Selected Compound</p>}
                            {path == 'PropertiesInBuilding' && <p>You can manage All Properties Inside the Selected Building</p>}
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by Unit Code, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={6} sm={8} className="mb-3">
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "all" ? "#556ee6" : "#f4f4f4",
                                    color: active == "all" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("all")
                                }}
                            >
                                All
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "active" ? "#556ee6" : "#f4f4f4",
                                    color: active == "active" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("active")
                                }}
                            >
                                Active
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                                    color: active == "deactive" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("deactive")
                                }}
                            >
                                Deactive
                            </button>
                        </Col>
                        <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">
                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive position-relative">
                                            <Table >
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">
                                                            I.D
                                                        </th>
                                                        <th className="font-size-14">
                                                            Unit Code
                                                        </th>
                                                        <th className="font-size-14">
                                                            Property Type
                                                        </th>
                                                        <th className="font-size-14">
                                                            Price
                                                        </th>
                                                        <th className="font-size-14">
                                                            Size
                                                        </th>
                                                        <th className="font-size-14">
                                                            No. of Bedrooms
                                                        </th>
                                                        <th className="font-size-14">
                                                            Sale Status
                                                        </th>
                                                        <th className="font-size-14">
                                                            Status
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map((item, index) => {
                                                        return (
                                                            <CardItem
                                                                key={index}
                                                                index={index}
                                                                {...item}
                                                                itemData={{...item}}
                                                                Service={PropertyService}
                                                                setShouldGetData={setShouldGetData}
                                                            />
                                                        )
                                                    })}
                                                </tbody>
                                                
                                                {noData && <b style={{
                                                    left: '50%',
                                                    position: 'absolute',
                                                    transform: 'translate(-50%, 15px)'
                                                }}>
                                                    {filter?.path == "allProperties" ? "There's no properties in the selected compound" : filter?.path == "PropertiesInBuilding" ? 
                                                        "There's no properties in the selected building " : 
                                                        "There's no standalone properties in the selected compound" }
                                                </b>}
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={propertyService}
                                    pageOptions={pageOptions}
                                    setData={(data) => {
                                        setList([...data])
                                        if(data?.length > 0){
                                            setNoData(false)
                                        } else{
                                            setNoData(true)
                                        }
                                    }}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row >
                    </div>
                    {modal ? <FilterModal
                        toggle={toggle}
                        modal={modal}
                        onSumbit={(data) => setFilterData(data)}
                        filterData={filterData}
                    /> : null}
                </Container>
            </div>
        </React.Fragment >
    )
}

export default PropertyList
